module.exports = __webpack_public_path__ + "static/media/research_01@2x.ec108ea2.png";